export default function buildDeliveryReceiptData({
  order,
  recipient,
  recipientDocument,
  recipientRelationship,
  signatureDataUrl,
  signatureDate,
}) {
  const addressParts = [
    order.consumer_address,
    order.consumer_address_detail,
    order.consumer_city,
  ].filter(Boolean);

  const consumerFirstName = order.consumer_first_name || '';
  const consumerLastName = order.consumer_last_name || '';
  const recipientName = `${consumerFirstName} ${consumerLastName}`.trim();

  return {
    recipientName,
    recipientFirstName: consumerFirstName,
    recipientLastName: consumerLastName,
    recipientAddress: addressParts.join(', ') || '-',
    receiverName: recipient,
    receiverId: recipientDocument,
    relationship: recipientRelationship,
    sender: order.ecommerce_name || order.id_ecommerce || '-',
    invoiceNumber: order.invoice_number || order.order_code || '-',
    shipment: order.invoice_number || order.order_code || '-',
    order: order.order_code || '-',
    boxes: order.package_count != null ? String(order.package_count) : '-',
    issueDate: order.created_at || new Date().toISOString(),
    signatureDateTime: signatureDate || new Date().toISOString(),
    signatureDataUrl,
  };
}
